import { useEffect, useRef, useState } from 'react';

type InViewOptions = {
  root?: Element | Document | null;
  rootMargin?: string;
  threshold?: number | number[];
};

export function useInView<T extends HTMLElement>(
  options?: InViewOptions,
) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, ...options },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [options]);

  return { ref, inView };
}
